/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AppRouteImport } from './routes/_app';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as InvitationRouteImport } from './routes/invitation';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ResetRouteImport } from './routes/reset';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as AppIndexRouteImport } from './routes/_app/index';
import { Route as AppCalendarRouteImport } from './routes/_app/calendar';
import { Route as AppMeRouteImport } from './routes/_app/me';
import { Route as AppTasksRouteImport } from './routes/_app/tasks';
import { Route as DevUiRouteImport } from './routes/dev/ui';
import { Route as InviteTokenRouteImport } from './routes/invite.$token';
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit';
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin/roles';
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings';
import { Route as AppAdminTaxesRouteImport } from './routes/_app/admin/taxes';
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId';
import { Route as AppCustomersCompaniesRouteImport } from './routes/_app/customers/companies';
import { Route as AppCustomersPeopleRouteImport } from './routes/_app/customers/people';
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index';
import { Route as AppReportsKindRouteImport } from './routes/_app/reports/$kind';
import { Route as AppReservationsIndexRouteImport } from './routes/_app/reservations/index';
import { Route as AppReservationsReservationIdRouteImport } from './routes/_app/reservations/$reservationId';
import { Route as AppReservationsNewRouteImport } from './routes/_app/reservations/new';
import { Route as AppResourcesIndexRouteImport } from './routes/_app/resources/index';
import { Route as AppResourcesResourceIdRouteImport } from './routes/_app/resources/$resourceId';
import { Route as AppResourcesAvailabilityRouteImport } from './routes/_app/resources/availability';
import { Route as AppResourcesMaintenanceRouteImport } from './routes/_app/resources/maintenance';
import { Route as AppTodayArrivalsRouteImport } from './routes/_app/today/arrivals';
import { Route as AppTodayDeparturesRouteImport } from './routes/_app/today/departures';
import { Route as AppTodayHousekeepingRouteImport } from './routes/_app/today/housekeeping';
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index';
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$userId';
import { Route as AppBillingCashIndexRouteImport } from './routes/_app/billing/cash/index';
import { Route as AppBillingCashSessionIdRouteImport } from './routes/_app/billing/cash/$sessionId';
import { Route as AppBillingCreditNotesIndexRouteImport } from './routes/_app/billing/credit-notes/index';
import { Route as AppBillingCreditNotesCreditNoteIdRouteImport } from './routes/_app/billing/credit-notes/$creditNoteId';
import { Route as AppBillingInvoicesIndexRouteImport } from './routes/_app/billing/invoices/index';
import { Route as AppBillingInvoicesInvoiceIdRouteImport } from './routes/_app/billing/invoices/$invoiceId';
import { Route as AppBillingPaymentsIndexRouteImport } from './routes/_app/billing/payments/index';
import { Route as AppBillingPaymentsPaymentIdRouteImport } from './routes/_app/billing/payments/$paymentId';
import { Route as AppBillingProformasIndexRouteImport } from './routes/_app/billing/proformas/index';
import { Route as AppBillingProformasProformaIdRouteImport } from './routes/_app/billing/proformas/$proformaId';
import { Route as AppFinanceExpensesIndexRouteImport } from './routes/_app/finance/expenses/index';
import { Route as AppFinanceExpensesExpenseIdRouteImport } from './routes/_app/finance/expenses/$expenseId';
import { Route as AppReservationsReservationIdCheckInRouteImport } from './routes/_app/reservations/$reservationId_.check-in';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any);
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any);
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any);
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any);
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminTaxesRoute = AppAdminTaxesRouteImport.update({
  id: '/admin/taxes',
  path: '/admin/taxes',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersCompaniesRoute = AppCustomersCompaniesRouteImport.update({
  id: '/customers/companies',
  path: '/customers/companies',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersPeopleRoute = AppCustomersPeopleRouteImport.update({
  id: '/customers/people',
  path: '/customers/people',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsKindRoute = AppReportsKindRouteImport.update({
  id: '/reports/$kind',
  path: '/reports/$kind',
  getParentRoute: () => AppRoute,
} as any);
const AppReservationsIndexRoute = AppReservationsIndexRouteImport.update({
  id: '/reservations/',
  path: '/reservations/',
  getParentRoute: () => AppRoute,
} as any);
const AppReservationsReservationIdRoute =
  AppReservationsReservationIdRouteImport.update({
    id: '/reservations/$reservationId',
    path: '/reservations/$reservationId',
    getParentRoute: () => AppRoute,
  } as any);
const AppReservationsNewRoute = AppReservationsNewRouteImport.update({
  id: '/reservations/new',
  path: '/reservations/new',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesIndexRoute = AppResourcesIndexRouteImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesResourceIdRoute = AppResourcesResourceIdRouteImport.update({
  id: '/resources/$resourceId',
  path: '/resources/$resourceId',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesAvailabilityRoute =
  AppResourcesAvailabilityRouteImport.update({
    id: '/resources/availability',
    path: '/resources/availability',
    getParentRoute: () => AppRoute,
  } as any);
const AppResourcesMaintenanceRoute = AppResourcesMaintenanceRouteImport.update({
  id: '/resources/maintenance',
  path: '/resources/maintenance',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayArrivalsRoute = AppTodayArrivalsRouteImport.update({
  id: '/today/arrivals',
  path: '/today/arrivals',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayDeparturesRoute = AppTodayDeparturesRouteImport.update({
  id: '/today/departures',
  path: '/today/departures',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayHousekeepingRoute = AppTodayHousekeepingRouteImport.update({
  id: '/today/housekeeping',
  path: '/today/housekeeping',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCashIndexRoute = AppBillingCashIndexRouteImport.update({
  id: '/billing/cash/',
  path: '/billing/cash/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCashSessionIdRoute = AppBillingCashSessionIdRouteImport.update({
  id: '/billing/cash/$sessionId',
  path: '/billing/cash/$sessionId',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCreditNotesIndexRoute =
  AppBillingCreditNotesIndexRouteImport.update({
    id: '/billing/credit-notes/',
    path: '/billing/credit-notes/',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingCreditNotesCreditNoteIdRoute =
  AppBillingCreditNotesCreditNoteIdRouteImport.update({
    id: '/billing/credit-notes/$creditNoteId',
    path: '/billing/credit-notes/$creditNoteId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingInvoicesIndexRoute = AppBillingInvoicesIndexRouteImport.update({
  id: '/billing/invoices/',
  path: '/billing/invoices/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingInvoicesInvoiceIdRoute =
  AppBillingInvoicesInvoiceIdRouteImport.update({
    id: '/billing/invoices/$invoiceId',
    path: '/billing/invoices/$invoiceId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingPaymentsIndexRoute = AppBillingPaymentsIndexRouteImport.update({
  id: '/billing/payments/',
  path: '/billing/payments/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingPaymentsPaymentIdRoute =
  AppBillingPaymentsPaymentIdRouteImport.update({
    id: '/billing/payments/$paymentId',
    path: '/billing/payments/$paymentId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingProformasIndexRoute =
  AppBillingProformasIndexRouteImport.update({
    id: '/billing/proformas/',
    path: '/billing/proformas/',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingProformasProformaIdRoute =
  AppBillingProformasProformaIdRouteImport.update({
    id: '/billing/proformas/$proformaId',
    path: '/billing/proformas/$proformaId',
    getParentRoute: () => AppRoute,
  } as any);
const AppFinanceExpensesIndexRoute = AppFinanceExpensesIndexRouteImport.update({
  id: '/finance/expenses/',
  path: '/finance/expenses/',
  getParentRoute: () => AppRoute,
} as any);
const AppFinanceExpensesExpenseIdRoute =
  AppFinanceExpensesExpenseIdRouteImport.update({
    id: '/finance/expenses/$expenseId',
    path: '/finance/expenses/$expenseId',
    getParentRoute: () => AppRoute,
  } as any);
const AppReservationsReservationIdCheckInRoute =
  AppReservationsReservationIdCheckInRouteImport.update({
    id: '/reservations/$reservationId_/check-in',
    path: '/reservations/$reservationId/check-in',
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/calendar': typeof AppCalendarRoute;
  '/me': typeof AppMeRoute;
  '/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/admin/audit': typeof AppAdminAuditRoute;
  '/admin/roles': typeof AppAdminRolesRoute;
  '/admin/settings': typeof AppAdminSettingsRoute;
  '/admin/taxes': typeof AppAdminTaxesRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/customers/companies': typeof AppCustomersCompaniesRoute;
  '/customers/people': typeof AppCustomersPeopleRoute;
  '/reports/$kind': typeof AppReportsKindRoute;
  '/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/reservations/new': typeof AppReservationsNewRoute;
  '/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/today/arrivals': typeof AppTodayArrivalsRoute;
  '/today/departures': typeof AppTodayDeparturesRoute;
  '/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/reports/': typeof AppReportsIndexRoute;
  '/reservations/': typeof AppReservationsIndexRoute;
  '/resources/': typeof AppResourcesIndexRoute;
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/reservations/$reservationId/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/admin/users/': typeof AppAdminUsersIndexRoute;
  '/billing/cash/': typeof AppBillingCashIndexRoute;
  '/billing/credit-notes/': typeof AppBillingCreditNotesIndexRoute;
  '/billing/invoices/': typeof AppBillingInvoicesIndexRoute;
  '/billing/payments/': typeof AppBillingPaymentsIndexRoute;
  '/billing/proformas/': typeof AppBillingProformasIndexRoute;
  '/finance/expenses/': typeof AppFinanceExpensesIndexRoute;
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/calendar': typeof AppCalendarRoute;
  '/me': typeof AppMeRoute;
  '/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/': typeof AppIndexRoute;
  '/admin/audit': typeof AppAdminAuditRoute;
  '/admin/roles': typeof AppAdminRolesRoute;
  '/admin/settings': typeof AppAdminSettingsRoute;
  '/admin/taxes': typeof AppAdminTaxesRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/customers/companies': typeof AppCustomersCompaniesRoute;
  '/customers/people': typeof AppCustomersPeopleRoute;
  '/reports/$kind': typeof AppReportsKindRoute;
  '/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/reservations/new': typeof AppReservationsNewRoute;
  '/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/today/arrivals': typeof AppTodayArrivalsRoute;
  '/today/departures': typeof AppTodayDeparturesRoute;
  '/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/reports': typeof AppReportsIndexRoute;
  '/reservations': typeof AppReservationsIndexRoute;
  '/resources': typeof AppResourcesIndexRoute;
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/reservations/$reservationId/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/admin/users': typeof AppAdminUsersIndexRoute;
  '/billing/cash': typeof AppBillingCashIndexRoute;
  '/billing/credit-notes': typeof AppBillingCreditNotesIndexRoute;
  '/billing/invoices': typeof AppBillingInvoicesIndexRoute;
  '/billing/payments': typeof AppBillingPaymentsIndexRoute;
  '/billing/proformas': typeof AppBillingProformasIndexRoute;
  '/finance/expenses': typeof AppFinanceExpensesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_app': typeof AppRouteWithChildren;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/_app/calendar': typeof AppCalendarRoute;
  '/_app/me': typeof AppMeRoute;
  '/_app/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/_app/': typeof AppIndexRoute;
  '/_app/admin/audit': typeof AppAdminAuditRoute;
  '/_app/admin/roles': typeof AppAdminRolesRoute;
  '/_app/admin/settings': typeof AppAdminSettingsRoute;
  '/_app/admin/taxes': typeof AppAdminTaxesRoute;
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/_app/customers/companies': typeof AppCustomersCompaniesRoute;
  '/_app/customers/people': typeof AppCustomersPeopleRoute;
  '/_app/reports/$kind': typeof AppReportsKindRoute;
  '/_app/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/_app/reservations/new': typeof AppReservationsNewRoute;
  '/_app/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/_app/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/_app/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/_app/today/arrivals': typeof AppTodayArrivalsRoute;
  '/_app/today/departures': typeof AppTodayDeparturesRoute;
  '/_app/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/_app/reports/': typeof AppReportsIndexRoute;
  '/_app/reservations/': typeof AppReservationsIndexRoute;
  '/_app/resources/': typeof AppResourcesIndexRoute;
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/_app/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/_app/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/_app/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/_app/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/_app/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/_app/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/_app/reservations/$reservationId_/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute;
  '/_app/billing/cash/': typeof AppBillingCashIndexRoute;
  '/_app/billing/credit-notes/': typeof AppBillingCreditNotesIndexRoute;
  '/_app/billing/invoices/': typeof AppBillingInvoicesIndexRoute;
  '/_app/billing/payments/': typeof AppBillingPaymentsIndexRoute;
  '/_app/billing/proformas/': typeof AppBillingProformasIndexRoute;
  '/_app/finance/expenses/': typeof AppFinanceExpensesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/calendar'
    | '/me'
    | '/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/admin/audit'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/taxes'
    | '/customers/$customerId'
    | '/customers/companies'
    | '/customers/people'
    | '/reports/$kind'
    | '/reservations/$reservationId'
    | '/reservations/new'
    | '/resources/$resourceId'
    | '/resources/availability'
    | '/resources/maintenance'
    | '/today/arrivals'
    | '/today/departures'
    | '/today/housekeeping'
    | '/reports/'
    | '/reservations/'
    | '/resources/'
    | '/admin/users/$userId'
    | '/billing/cash/$sessionId'
    | '/billing/credit-notes/$creditNoteId'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/billing/proformas/$proformaId'
    | '/finance/expenses/$expenseId'
    | '/reservations/$reservationId/check-in'
    | '/admin/users/'
    | '/billing/cash/'
    | '/billing/credit-notes/'
    | '/billing/invoices/'
    | '/billing/payments/'
    | '/billing/proformas/'
    | '/finance/expenses/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/calendar'
    | '/me'
    | '/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/'
    | '/admin/audit'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/taxes'
    | '/customers/$customerId'
    | '/customers/companies'
    | '/customers/people'
    | '/reports/$kind'
    | '/reservations/$reservationId'
    | '/reservations/new'
    | '/resources/$resourceId'
    | '/resources/availability'
    | '/resources/maintenance'
    | '/today/arrivals'
    | '/today/departures'
    | '/today/housekeeping'
    | '/reports'
    | '/reservations'
    | '/resources'
    | '/admin/users/$userId'
    | '/billing/cash/$sessionId'
    | '/billing/credit-notes/$creditNoteId'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/billing/proformas/$proformaId'
    | '/finance/expenses/$expenseId'
    | '/reservations/$reservationId/check-in'
    | '/admin/users'
    | '/billing/cash'
    | '/billing/credit-notes'
    | '/billing/invoices'
    | '/billing/payments'
    | '/billing/proformas'
    | '/finance/expenses';
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/_app/calendar'
    | '/_app/me'
    | '/_app/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/roles'
    | '/_app/admin/settings'
    | '/_app/admin/taxes'
    | '/_app/customers/$customerId'
    | '/_app/customers/companies'
    | '/_app/customers/people'
    | '/_app/reports/$kind'
    | '/_app/reservations/$reservationId'
    | '/_app/reservations/new'
    | '/_app/resources/$resourceId'
    | '/_app/resources/availability'
    | '/_app/resources/maintenance'
    | '/_app/today/arrivals'
    | '/_app/today/departures'
    | '/_app/today/housekeeping'
    | '/_app/reports/'
    | '/_app/reservations/'
    | '/_app/resources/'
    | '/_app/admin/users/$userId'
    | '/_app/billing/cash/$sessionId'
    | '/_app/billing/credit-notes/$creditNoteId'
    | '/_app/billing/invoices/$invoiceId'
    | '/_app/billing/payments/$paymentId'
    | '/_app/billing/proformas/$proformaId'
    | '/_app/finance/expenses/$expenseId'
    | '/_app/reservations/$reservationId_/check-in'
    | '/_app/admin/users/'
    | '/_app/billing/cash/'
    | '/_app/billing/credit-notes/'
    | '/_app/billing/invoices/'
    | '/_app/billing/payments/'
    | '/_app/billing/proformas/'
    | '/_app/finance/expenses/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  InvitationRoute: typeof InvitationRoute;
  LoginRoute: typeof LoginRoute;
  ResetRoute: typeof ResetRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  DevUiRoute: typeof DevUiRoute;
  InviteTokenRoute: typeof InviteTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invitation': {
      id: '/invitation';
      path: '/invitation';
      fullPath: '/invitation';
      preLoaderRoute: typeof InvitationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset': {
      id: '/reset';
      path: '/reset';
      fullPath: '/reset';
      preLoaderRoute: typeof ResetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/calendar': {
      id: '/_app/calendar';
      path: '/calendar';
      fullPath: '/calendar';
      preLoaderRoute: typeof AppCalendarRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/me': {
      id: '/_app/me';
      path: '/me';
      fullPath: '/me';
      preLoaderRoute: typeof AppMeRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/tasks': {
      id: '/_app/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof AppTasksRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/dev/ui': {
      id: '/dev/ui';
      path: '/dev/ui';
      fullPath: '/dev/ui';
      preLoaderRoute: typeof DevUiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invite/$token': {
      id: '/invite/$token';
      path: '/invite/$token';
      fullPath: '/invite/$token';
      preLoaderRoute: typeof InviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/admin/audit': {
      id: '/_app/admin/audit';
      path: '/admin/audit';
      fullPath: '/admin/audit';
      preLoaderRoute: typeof AppAdminAuditRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/roles': {
      id: '/_app/admin/roles';
      path: '/admin/roles';
      fullPath: '/admin/roles';
      preLoaderRoute: typeof AppAdminRolesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/settings': {
      id: '/_app/admin/settings';
      path: '/admin/settings';
      fullPath: '/admin/settings';
      preLoaderRoute: typeof AppAdminSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/taxes': {
      id: '/_app/admin/taxes';
      path: '/admin/taxes';
      fullPath: '/admin/taxes';
      preLoaderRoute: typeof AppAdminTaxesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId';
      path: '/customers/$customerId';
      fullPath: '/customers/$customerId';
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/companies': {
      id: '/_app/customers/companies';
      path: '/customers/companies';
      fullPath: '/customers/companies';
      preLoaderRoute: typeof AppCustomersCompaniesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/people': {
      id: '/_app/customers/people';
      path: '/customers/people';
      fullPath: '/customers/people';
      preLoaderRoute: typeof AppCustomersPeopleRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reports/': {
      id: '/_app/reports/';
      path: '/reports';
      fullPath: '/reports/';
      preLoaderRoute: typeof AppReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reports/$kind': {
      id: '/_app/reports/$kind';
      path: '/reports/$kind';
      fullPath: '/reports/$kind';
      preLoaderRoute: typeof AppReportsKindRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/': {
      id: '/_app/reservations/';
      path: '/reservations';
      fullPath: '/reservations/';
      preLoaderRoute: typeof AppReservationsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/$reservationId': {
      id: '/_app/reservations/$reservationId';
      path: '/reservations/$reservationId';
      fullPath: '/reservations/$reservationId';
      preLoaderRoute: typeof AppReservationsReservationIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/new': {
      id: '/_app/reservations/new';
      path: '/reservations/new';
      fullPath: '/reservations/new';
      preLoaderRoute: typeof AppReservationsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/': {
      id: '/_app/resources/';
      path: '/resources';
      fullPath: '/resources/';
      preLoaderRoute: typeof AppResourcesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/$resourceId': {
      id: '/_app/resources/$resourceId';
      path: '/resources/$resourceId';
      fullPath: '/resources/$resourceId';
      preLoaderRoute: typeof AppResourcesResourceIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/availability': {
      id: '/_app/resources/availability';
      path: '/resources/availability';
      fullPath: '/resources/availability';
      preLoaderRoute: typeof AppResourcesAvailabilityRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/maintenance': {
      id: '/_app/resources/maintenance';
      path: '/resources/maintenance';
      fullPath: '/resources/maintenance';
      preLoaderRoute: typeof AppResourcesMaintenanceRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/arrivals': {
      id: '/_app/today/arrivals';
      path: '/today/arrivals';
      fullPath: '/today/arrivals';
      preLoaderRoute: typeof AppTodayArrivalsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/departures': {
      id: '/_app/today/departures';
      path: '/today/departures';
      fullPath: '/today/departures';
      preLoaderRoute: typeof AppTodayDeparturesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/housekeeping': {
      id: '/_app/today/housekeeping';
      path: '/today/housekeeping';
      fullPath: '/today/housekeeping';
      preLoaderRoute: typeof AppTodayHousekeepingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/users/': {
      id: '/_app/admin/users/';
      path: '/admin/users';
      fullPath: '/admin/users/';
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId';
      path: '/admin/users/$userId';
      fullPath: '/admin/users/$userId';
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/cash/': {
      id: '/_app/billing/cash/';
      path: '/billing/cash';
      fullPath: '/billing/cash/';
      preLoaderRoute: typeof AppBillingCashIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/cash/$sessionId': {
      id: '/_app/billing/cash/$sessionId';
      path: '/billing/cash/$sessionId';
      fullPath: '/billing/cash/$sessionId';
      preLoaderRoute: typeof AppBillingCashSessionIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/credit-notes/': {
      id: '/_app/billing/credit-notes/';
      path: '/billing/credit-notes';
      fullPath: '/billing/credit-notes/';
      preLoaderRoute: typeof AppBillingCreditNotesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/credit-notes/$creditNoteId': {
      id: '/_app/billing/credit-notes/$creditNoteId';
      path: '/billing/credit-notes/$creditNoteId';
      fullPath: '/billing/credit-notes/$creditNoteId';
      preLoaderRoute: typeof AppBillingCreditNotesCreditNoteIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/invoices/': {
      id: '/_app/billing/invoices/';
      path: '/billing/invoices';
      fullPath: '/billing/invoices/';
      preLoaderRoute: typeof AppBillingInvoicesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/invoices/$invoiceId': {
      id: '/_app/billing/invoices/$invoiceId';
      path: '/billing/invoices/$invoiceId';
      fullPath: '/billing/invoices/$invoiceId';
      preLoaderRoute: typeof AppBillingInvoicesInvoiceIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/payments/': {
      id: '/_app/billing/payments/';
      path: '/billing/payments';
      fullPath: '/billing/payments/';
      preLoaderRoute: typeof AppBillingPaymentsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/payments/$paymentId': {
      id: '/_app/billing/payments/$paymentId';
      path: '/billing/payments/$paymentId';
      fullPath: '/billing/payments/$paymentId';
      preLoaderRoute: typeof AppBillingPaymentsPaymentIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/proformas/': {
      id: '/_app/billing/proformas/';
      path: '/billing/proformas';
      fullPath: '/billing/proformas/';
      preLoaderRoute: typeof AppBillingProformasIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/proformas/$proformaId': {
      id: '/_app/billing/proformas/$proformaId';
      path: '/billing/proformas/$proformaId';
      fullPath: '/billing/proformas/$proformaId';
      preLoaderRoute: typeof AppBillingProformasProformaIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/finance/expenses/': {
      id: '/_app/finance/expenses/';
      path: '/finance/expenses';
      fullPath: '/finance/expenses/';
      preLoaderRoute: typeof AppFinanceExpensesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/finance/expenses/$expenseId': {
      id: '/_app/finance/expenses/$expenseId';
      path: '/finance/expenses/$expenseId';
      fullPath: '/finance/expenses/$expenseId';
      preLoaderRoute: typeof AppFinanceExpensesExpenseIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/$reservationId_/check-in': {
      id: '/_app/reservations/$reservationId_/check-in';
      path: '/reservations/$reservationId/check-in';
      fullPath: '/reservations/$reservationId/check-in';
      preLoaderRoute: typeof AppReservationsReservationIdCheckInRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute;
  AppMeRoute: typeof AppMeRoute;
  AppTasksRoute: typeof AppTasksRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppAdminAuditRoute: typeof AppAdminAuditRoute;
  AppAdminRolesRoute: typeof AppAdminRolesRoute;
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute;
  AppAdminTaxesRoute: typeof AppAdminTaxesRoute;
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute;
  AppCustomersCompaniesRoute: typeof AppCustomersCompaniesRoute;
  AppCustomersPeopleRoute: typeof AppCustomersPeopleRoute;
  AppReportsKindRoute: typeof AppReportsKindRoute;
  AppReservationsReservationIdRoute: typeof AppReservationsReservationIdRoute;
  AppReservationsNewRoute: typeof AppReservationsNewRoute;
  AppResourcesResourceIdRoute: typeof AppResourcesResourceIdRoute;
  AppResourcesAvailabilityRoute: typeof AppResourcesAvailabilityRoute;
  AppResourcesMaintenanceRoute: typeof AppResourcesMaintenanceRoute;
  AppTodayArrivalsRoute: typeof AppTodayArrivalsRoute;
  AppTodayDeparturesRoute: typeof AppTodayDeparturesRoute;
  AppTodayHousekeepingRoute: typeof AppTodayHousekeepingRoute;
  AppReportsIndexRoute: typeof AppReportsIndexRoute;
  AppReservationsIndexRoute: typeof AppReservationsIndexRoute;
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute;
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute;
  AppBillingCashSessionIdRoute: typeof AppBillingCashSessionIdRoute;
  AppBillingCreditNotesCreditNoteIdRoute: typeof AppBillingCreditNotesCreditNoteIdRoute;
  AppBillingInvoicesInvoiceIdRoute: typeof AppBillingInvoicesInvoiceIdRoute;
  AppBillingPaymentsPaymentIdRoute: typeof AppBillingPaymentsPaymentIdRoute;
  AppBillingProformasProformaIdRoute: typeof AppBillingProformasProformaIdRoute;
  AppFinanceExpensesExpenseIdRoute: typeof AppFinanceExpensesExpenseIdRoute;
  AppReservationsReservationIdCheckInRoute: typeof AppReservationsReservationIdCheckInRoute;
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute;
  AppBillingCashIndexRoute: typeof AppBillingCashIndexRoute;
  AppBillingCreditNotesIndexRoute: typeof AppBillingCreditNotesIndexRoute;
  AppBillingInvoicesIndexRoute: typeof AppBillingInvoicesIndexRoute;
  AppBillingPaymentsIndexRoute: typeof AppBillingPaymentsIndexRoute;
  AppBillingProformasIndexRoute: typeof AppBillingProformasIndexRoute;
  AppFinanceExpensesIndexRoute: typeof AppFinanceExpensesIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppMeRoute: AppMeRoute,
  AppTasksRoute: AppTasksRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminTaxesRoute: AppAdminTaxesRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppCustomersCompaniesRoute: AppCustomersCompaniesRoute,
  AppCustomersPeopleRoute: AppCustomersPeopleRoute,
  AppReportsKindRoute: AppReportsKindRoute,
  AppReservationsReservationIdRoute: AppReservationsReservationIdRoute,
  AppReservationsNewRoute: AppReservationsNewRoute,
  AppResourcesResourceIdRoute: AppResourcesResourceIdRoute,
  AppResourcesAvailabilityRoute: AppResourcesAvailabilityRoute,
  AppResourcesMaintenanceRoute: AppResourcesMaintenanceRoute,
  AppTodayArrivalsRoute: AppTodayArrivalsRoute,
  AppTodayDeparturesRoute: AppTodayDeparturesRoute,
  AppTodayHousekeepingRoute: AppTodayHousekeepingRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppReservationsIndexRoute: AppReservationsIndexRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppBillingCashSessionIdRoute: AppBillingCashSessionIdRoute,
  AppBillingCreditNotesCreditNoteIdRoute:
    AppBillingCreditNotesCreditNoteIdRoute,
  AppBillingInvoicesInvoiceIdRoute: AppBillingInvoicesInvoiceIdRoute,
  AppBillingPaymentsPaymentIdRoute: AppBillingPaymentsPaymentIdRoute,
  AppBillingProformasProformaIdRoute: AppBillingProformasProformaIdRoute,
  AppFinanceExpensesExpenseIdRoute: AppFinanceExpensesExpenseIdRoute,
  AppReservationsReservationIdCheckInRoute:
    AppReservationsReservationIdCheckInRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppBillingCashIndexRoute: AppBillingCashIndexRoute,
  AppBillingCreditNotesIndexRoute: AppBillingCreditNotesIndexRoute,
  AppBillingInvoicesIndexRoute: AppBillingInvoicesIndexRoute,
  AppBillingPaymentsIndexRoute: AppBillingPaymentsIndexRoute,
  AppBillingProformasIndexRoute: AppBillingProformasIndexRoute,
  AppFinanceExpensesIndexRoute: AppFinanceExpensesIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InvitationRoute: InvitationRoute,
  LoginRoute: LoginRoute,
  ResetRoute: ResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  DevUiRoute: DevUiRoute,
  InviteTokenRoute: InviteTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
